<template>
    <el-dialog :model-value="modelValue" title="会议人员选择" @open="handleOpen" @close="handleCancel" width="850px">
        <el-row class="user-list" :gutter="20">
            <el-col :span="5">
                <el-tree
                    :data="deptList"
                    :props="defaultProps"
                    ref="treeRef"
                    default-expand-all
                    highlight-current
                    @node-click="handleNodeClick"
                />
            </el-col>
            <el-col :span="18">
                <Transition name="fade">
                    <el-form
                        v-if="formVisible"
                        :inline="true"
                        label-position="top"
                        class="search-form"
                        :model="search_data"
                        style="padding: 0"
                    >
                        <el-form-item label="姓名">
                            <el-input v-model="search_data.username" clearable placeholder="请输入" style="width: 150px" />
                        </el-form-item>
                        <el-form-item label="手机号码">
                            <el-input v-model="search_data.phone" clearable placeholder="请输入" style="width: 150px" />
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" :icon="Search" @click="getTableData">搜索</el-button>
                            <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
                        </el-form-item>
                    </el-form>
                </Transition>

                <el-table
                    :data="table_data"
                    v-loading="tableLoading"
                    ref="multipleTableRef"
                    @selection-change="handleSelectionChange"
                    style="width: 100%"
                    border
                >
                    <el-table-column type="selection" width="55" />
                    <el-table-column label="序号" type="index" width="60" />
                    <el-table-column prop="name" label="姓名"></el-table-column>
                    <el-table-column prop="department_show" label="部门"></el-table-column>
                    <el-table-column prop="phone" label="手机号码" width="120"></el-table-column>
                    <el-table-column prop="create_time" label="添加时间" width="160"></el-table-column>
                </el-table>
                <el-pagination
                    class="pagination"
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="search_data.page"
                    :page-sizes="[10, 20, 50]"
                    :page-size="search_data.page_size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </el-col>
        </el-row>
        <div style="display: flex; width: 95%; justify-content: end; margin-top: 20px">
            <el-button @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="onAddClick">确定</el-button>
        </div>
    </el-dialog>
</template>

<script setup>
import { defineEmits, defineProps, nextTick, onMounted, ref, watch } from 'vue'
import { getOperationLists } from '@/api/operation'
import { getDepartmentTree } from '@/api/dept.js'
import { Refresh, Search } from '@element-plus/icons'

const props = defineProps({
    modelValue: {
        type: Boolean,
        default: false,
        required: true
    },
    userTags: {
        type: Array
    }
})

const emits = defineEmits(['update:modelValue', 'getManList'])

// 数据源
const search_data = ref({
    username: '',
    master: '',
    phone: '',
    page: 1,
    page_size: 10,
    department: '',
    status: ''
})
const table_data = ref([])
const tableLoading = ref(true)
const total = ref(0)

const handleOpen = () => {
    // if (props.userTags.length) {
    //     toggleSelection(props.userTags)
    // }
}

const multipleTableRef = ref()
const toggleSelection = (rows) => {
    if (rows) {
        table_data.value.forEach((item, index) => {
            rows.forEach((row, index) => {
                if (item.id === row.id) {
                    multipleTableRef.value.toggleRowSelection(item, true)
                }
            })
        })
    } else {
        multipleTableRef.value.clearSelection()
    }
}

// 重置
const resetQueryForm = () => {
    Object.keys(search_data.value).forEach((key) => {
        if (key !== 'page' && key !== 'page_size') search_data.value[key] = ''
    })
    getTableData()
}
const formVisible = ref(true)
const currentUser = JSON.parse(localStorage.getItem('userInfo')).id
// 获取列表数据
const getTableData = async () => {
    tableLoading.value = true
    const res = await getOperationLists(search_data.value)
    tableLoading.value = false
    table_data.value = res.lists
    nextTick(() => {
        if (props.userTags) {
            toggleSelection([...props.userTags])
        }
    })
    if (res.lists.length && res.lists.find((ele) => ele.id === currentUser)) {
        let client = ''
        table_data.value.forEach((ele, index) => {
            if (ele.id === currentUser) {
                client = ele
                table_data.value.splice(index, 1)
            }
        })
        table_data.value.unshift(client)
    }
    total.value = res.total
}
getTableData()

const formDialogVisible = ref(false)
// const isForm = ref(false) // 是否是表单
const selectId = ref('') // 点中的运营单位id
// 保证每次打开重新获取数据
watch(formDialogVisible, (val) => {
    if (!val) {
        selectId.value = ''
    }
})

// 分页相关
// page_size 改变触发
const handleSizeChange = (currentSize) => {
    search_data.value.page_size = currentSize
    getTableData()
}
// 页码改变触发
const handleCurrentChange = (currentPage) => {
    search_data.value.page = currentPage
    getTableData()
}

// 部门列表
const deptList = ref([])
// 获取数据的方法
const getDeptListData = async () => {
    deptList.value = await getDepartmentTree()
}
const defaultProps = {
    children: 'children',
    label: 'name'
}

const handleNodeClick = (data) => {
    search_data.value.department = data.id
    getTableData()
}

// 被选择的人员列表
const selectMan = ref()

// 选择人
const handleSelectionChange = (val) => {
    selectMan.value = val
}
// 添加参会人员
const onAddClick = () => {
    emits('getManList', selectMan.value)
    // console.log(selectMan.value)
    emits('update:modelValue', false)
}
const handleCancel = () => {
    emits('update:modelValue', false)
}
// 被 keep-alive 缓存的组件激活时调用
onMounted(() => {
    getDeptListData()
    getTableData()
})
</script>

<style lang="scss" scoped></style>
